<template>
  <div id="app" :class="$language.get()">
    <topBar></topBar>
    <router-view/>
    <footerModule/>
  </div>
</template>

<script>
import footerModule from "@/components/footer";
import topBar from "@/components/topBar"

export default {
  name: 'App',
  components: {
    topBar, footerModule
  },
  data: () => {
    return {
      lang: 'zh'
    }
  },
  created(){
    this.$language.init();
  },
  computed: {
    key() {
      return this.$route.fullPath;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue